module.exports = __webpack_public_path__ + "img/tab3Image.6eb71aa2.png";